export enum FindingsStatus {
  INFO = 'INFO',
  FAILURE = 'FAILURE',
  WARNING = 'WARNING',
  SUCCESS = 'SUCCESS',
}
